var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightGrayEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 15,
    viewBox: "0 0 10 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.74695 11.0974L5.97827 2.66772L6.8428 2.39648L9.57135 10.6976L9.4838 10.8654L8.74695 11.0974Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2017 12.3849L1.47314 4.08373L2.34132 3.8125L5.11365 12.2421L4.37679 12.4705L4.2017 12.3849Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.47146 4.08225L1.75061 4.93164L7.11941 3.24275L6.84026 2.39336L1.47146 4.08225Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.912869 2.38694L1.19202 3.23633L6.56081 1.54744L6.28166 0.698049L0.912869 2.38694Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82303 11.2424L4.10217 12.0918L9.47097 10.4029L9.19182 9.55352L3.82303 11.2424Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99695 12.7844L9.16273 11.4746L8.57543 12.5952L6.146 13.359L4.99695 12.7844Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.94128 13.758L7.35713 12.9657L7.897 11.9343L8.76153 10.2891L9.57134 10.6959L9.48379 10.8636L9.16279 11.4739L8.57549 12.5945L8.51713 12.7087L8.18883 13.3333L8.16694 13.3726L7.75109 14.1648L6.94128 13.758Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.20178 12.3857L4.61763 11.5898L6.22631 12.4L7.35713 12.9674L7.37171 12.9746L8.16693 13.3743L7.75108 14.1666L4.20178 12.3857Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightGrayEdit);
export default __webpack_public_path__ + "static/media/lightGrayEdit.7019f373710e27e5cb3e93788d9d323b.svg";
export { ForwardRef as ReactComponent };